import I18nKey from "./keys";

const I18nStringsEnglish: Record<string, string> = {
    [I18nKey.GameNotificationTurn]: 'It is your turn in {{game}}',
    [I18nKey.GameNotificationTurnTitle]: 'Memento Mori (#{{gameId}})',
    [I18nKey.GameNotificationEliminated]: 'Et tu, {{eliminator}}? You\'ve been eliminated from {{game}}',
    [I18nKey.GameNotificationEliminatedTitle]: 'Et tu, {{eliminator}}? (#{{gameId}})',
    [I18nKey.GameNotificationInvite]: '{{inviter}} has invited you to play SPQR: {{game}}',
    [I18nKey.GameNotificationInviteTitle]: 'Beware the Ides of March!',
    [I18nKey.GameNotificationNotifyCreator]: 'Players are waiting for you to start in {{game}}',
    [I18nKey.GameNotificationNotifyCreatorTitle]: 'Memento Vivere (#{{gameId}})',
    [I18nKey.GameNotificationTeamChatMessage]: '(Team) {{sender}}: {{text}}',
    [I18nKey.GameNotificationChatMessage]: '{{sender}}: {{text}}',
    [I18nKey.GameNotificationChatMessageTitle]: 'Chat (#{{gameId}})',
};

export default I18nStringsEnglish;
